<app-header-style-two></app-header-style-two>

<div class="page-title-area">
    <div class="container">
        <h1>About Lama Driving School</h1>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img [src]="createImgPath(aboutUsPages.img1)" class="shadow" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <h4 style="color: #3b3771;">{{aboutUsPages?.title}}</h4>
                    <p style="color: white;" [innerHtml]="getSafeHtml(aboutUsPages?.shortText)">
                    </p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="about-content" style="color: white;">
                    <p style="color: white;" [innerHtml]="getSafeHtml(aboutUsPages?.fullText)">
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>